import React from 'react';
import { Link } from 'gatsby';
import { Box, Container, Divider, Grid, Stack, Typography } from '@mui/material';
import Logo from './Logo';
import { SITE } from '../data/site';
import { services } from '../data/services';

const companyLinks = [
  { label: 'About', to: '/about/' },
  { label: 'Contact', to: '/contact/' },
  { label: 'Privacy Policy', to: '/privacy/' },
  { label: 'Terms of Service', to: '/terms/' },
  { label: 'Cookie Policy', to: '/cookies/' },
];

export default function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: '#0F172A', color: '#94A3B8', pt: 6, pb: 4 }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={5}>
            <Logo light />
            <Typography sx={{ mt: 2, fontSize: 15, maxWidth: 380 }}>
              Product-first technology and AI consulting for growing businesses.
              We build the products we consult about.
            </Typography>
            <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
              {['services', 'about', 'contact'].map((r) => (
                <Link key={r} to={`/${r}/`} style={{ color: '#CBD5E1', textDecoration: 'none' }}>
                  <Typography sx={{ fontSize: 14, '&:hover': { color: '#fff' } }}>
                    {r === 'services' ? 'Services' : r === 'about' ? 'About' : 'Contact'}
                  </Typography>
                </Link>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>Services</Typography>
            <Grid container spacing={0}>
              {services.map((s) => (
                <Grid item xs={6} key={s.slug}>
                  <Link
                    to={`/services/${s.slug}/`}
                    style={{ textDecoration: 'none', color: '#94A3B8' }}
                  >
                    <Typography sx={{ fontSize: 14, py: 0.4, '&:hover': { color: '#fff' } }}>
                      {s.name}
                    </Typography>
                  </Link>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Typography sx={{ color: '#fff', fontWeight: 700, mb: 1.5 }}>Company</Typography>
            {companyLinks.map((l) => (
              <Link key={l.to} to={l.to} style={{ textDecoration: 'none', color: '#94A3B8' }}>
                <Typography sx={{ fontSize: 14, py: 0.4, '&:hover': { color: '#fff' } }}>
                  {l.label}
                </Typography>
              </Link>
            ))}
            <Typography sx={{ fontSize: 14, pt: 1 }}>
              Email: <a href={`mailto:${SITE.email}`} style={{ color: '#93C5FD' }}>{SITE.email}</a>
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 4 }} />
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          spacing={1}
          sx={{ fontSize: 13 }}
        >
          <Typography sx={{ fontSize: 13 }}>© {new Date().getFullYear()} CredInTech. All rights reserved.</Typography>
          <Typography sx={{ fontSize: 12, maxWidth: 520 }}>
            {SITE.entity} · CIN {SITE.cin} · GSTIN {SITE.gstin}
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}
